import React, { useState, useEffect } from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const [policyTextJP, setPolicyTextJP] = useState("");
  const [policyTextEN, setPolicyTextEN] = useState("");

  // テキストファイルを取得
  useEffect(() => {
    fetch("/privacy-policy-jp.txt")
      .then((response) => response.text())
      .then((text) => setPolicyTextJP(text))
      .catch((error) => console.error("Error loading privacy policy:", error));
  }, []);

  useEffect(() => {
    fetch("/privacy-policy-en.txt")
      .then((response) => response.text())
      .then((text) => setPolicyTextEN(text))
      .catch((error) => console.error("Error loading privacy policy:", error));
  }, []);


  return (
    <div className="privacy-policy">
      <h1>個人情報保護方針 / Privacy Policy</h1>
      <section className="policy-section">
        <pre>{policyTextJP}</pre>
      </section>
      <section className="policy-section">
        <h3>個人情報の利用目的</h3>
          <div>当社は、取得した個人情報を、以下の目的の範囲内で利用いたします。</div>
        <h4>１．採用応募者の個人情報</h4>
          <div><ul>
            <li>採用選考の実施</li>
            <li>面接日程等の連絡</li>
            <li>採否の通知</li>
            <li>採用に関する各種お問い合わせへの対応</li>
            <li>入社手続き（採用となった場合）</li>
          </ul></div>
        <h4>２．従業員の個人情報</h4>
          <div><ul>
            <li>雇用管理（入社・退職・異動・人事評価等）</li>
            <li>給与・賞与・社会保険・福利厚生等の手続き</li>
            <li>労務管理及び健康管理</li>
            <li>業務上必要な連絡</li>
            <li>教育・研修の実施</li>
            <li>法令に基づく各種手続き</li>
            <li>情報セキュリティ管理</li>
          </ul></div>
        <h4>３．お問い合わせいただいた方の個人情報</h4>
          <div><ul>
            <li>お問い合わせへの回答</li>
            <li>ご相談への対応</li>
            <li>当社サービスに関するご案内</li>
            <li>お問い合わせ内容の管理及び品質向上</li>
          </ul></div>
        <h4>４．お取引先ご担当者様の個人情報</h4>
          <div><ul>
            <li>業務上の連絡</li>
            <li>契約の締結及び履行</li>
            <li>商談・打ち合わせ</li>
            <li>請求・支払等の事務手続き</li>
          </ul></div>
      </section>
      <section className="policy-section">
        <h3>個人情報の安全管理のために講じた措置について</h3>
          <div>当社では、個人情報をより厳正に取り扱うため、JIS Q 15001に準拠した個人情報保護方針を基に、個人情報保護規程等を策定し、外的環境を把握した上で個人情報保護マネジメントシステムを運用しております。また、実際に個人情報を取り扱うにあたり、組織的、人的、物理的、技術的の4つの観点より安全管理措置を講じております。</div>
        <h4>（組織的安全管理措置）</h4>
          <div>① 個人データの取り扱いに関する個人情報保護管理者を設置するとともに、役職員等が取り扱う個人データの範囲を明確化し、法や規程に違反している事実又は兆候を把握した場合の個人情報保護管理者への報告連絡体制を整備しています。<br></br>
          ② 個人データの取扱状況について、定期的に内部監査を実施しています。</div>
        <h4>（人的安全管理措置）</h4>
          <div>① 個人データの取り扱いに関する留意事項（個人情報の取り扱いにおける事故報告にみる傾向と注意点の社内周知、事故発生時の対応方法など）について、役職員等に定期的な研修を実施しています。<br></br>
          ② 個人データについての秘密保持に関する事項に対して、役職員等から誓約書を受理しています。</div>
        <h4>（物理的安全管理措置）</h4>
          <div>① 情報システムを管理する区域においては、入退室管理システムの設置等により、適切な措置を講じています。<br></br>
          ② 個人データを取り扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するために、適切な措置を講じています。<br></br>
          ③ 個人データが記録された電子媒体又は書類等を持ち運ぶ場合、容易に個人データが判明しないよう、安全な方策を講じています。<br></br>
          ④ 個人データを削除し又は個人データが記録された機器、電子媒体等を廃棄する場合は、復元不可能な手段を講じています。</div>
        <h4>（技術的安全管理措置）</h4>
          <div>① 担当者及び取り扱う個人情報データベース等の範囲を限定するために、適切なアクセス制御を講じています。<br></br>
          ② 情報システムを使用する役職員等が正当なアクセス権を有する者であることを、ユーザーID、パスワード等により認証しています。<br></br>
          ③ 個人データを取り扱う情報システムを外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入し、適切に運用しています。<br></br>
          ④ 情報システムの使用に伴う個人データの漏えい等を防止するための措置を講じ、適切に運用しています。</div>
      </section>
      <section className="policy-section">
        <h3>個人情報の開示等の請求について</h3>
          <div>当社は、当社が保有する個人情報（保有個人データ）について、ご本人またはその代理人からの開示等のご請求に適切に対応いたします。</div>
        <h4>１．開示等の対象</h4>
          <div>ご本人は、当社に対し、以下の請求を行うことができます。
          <ul>
            <li>利用目的の通知</li>
            <li>開示</li>
            <li>内容の訂正、追加または削除</li>
            <li>利用の停止または消去</li>
            <li>第三者提供の停止</li>
          </ul></div>
        <h4>２．請求方法</h4>
          <div>開示等のご請求は、下記窓口まで電話またはメールにてご連絡ください。<br></br>
          当社より所定の請求書様式を送付いたします。<br></br>
          請求書に必要事項をご記入のうえ、本人確認書類を添付し、当社指定の方法によりご返送ください。</div>
          <h4>３．本人確認について</h4>
          <div>ご請求にあたっては、ご本人であることを確認するため、以下の書類の提示または提出をお願いいたします。<br></br>
          （例）<br></br>
          <ul>
            <li>運転免許証</li>
            <li>マイナンバーカード（表面のみ）</li>
            <li>パスポート 等</li>
          </ul>
          ※本籍地等の機微情報は、あらかじめ黒塗りのうえご提出ください。</div>
        <h4>４．代理人による請求</h4>
          <div>代理人によるご請求の場合は、以下の書類をご提出いただきます。<br></br>
          <ul>
            <li>ご本人確認書類</li>
            <li>代理人の本人確認書類</li>
            <li>委任状（ご本人の署名または記名押印）</li>
          </ul>
          ※未成年者の法定代理人の場合は、戸籍謄本等の関係確認書類をご提出いただく場合があります。</div>
        <h4>５．手数料</h4>
          <div>開示及び利用目的の通知に関するご請求については、１件あたり1,000円を銀行振り込みで頂戴いたします。</div>
        <h4>６．回答方法および回答期間</h4>
          <div>ご請求内容を確認のうえ、合理的な期間内（原則として2週間以内）に、書面または電磁的方法により回答いたします。</div>
        <h4>７．開示等に応じられない場合</h4>
          <div>以下の場合には、開示等のご請求に応じられないことがあります。<br></br>
          その場合は、理由を付してご通知いたします。
          <ul>
            <li>ご本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
            <li>当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
            <li>法令に違反することとなる場合</li>
          </ul></div>
        <h4>８．個人情報に関するお問い合わせ窓口</h4>
          <div className="contact-box">株式会社 IT plus<br></br>
          個人情報相談窓口<br></br>
          個人情報保護管理者：田中 康一<br></br>
          TEL：052-684-5742<br></br>
          メール：security@i-t-plus.co.jp<br></br>
          受付時間：平日 9:00～18:00（※土日祝日、年末年始を除く）</div>
      </section>
      <section className="policy-section">
        <pre>{policyTextEN}</pre>
      </section>
    </div>
    
  );
};

export default PrivacyPolicy;
